import { change } from 'redux-form'
import { FORM_NAME } from '../../../Form'

export default (event) => (dispatch) => {

  dispatch(change(FORM_NAME, 'type', event.target.value))

}